import {Button, Form, Input, Select, Space} from "antd";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useTranslation} from "react-i18next";
import {useRef} from "react";
import RoleSelectBox from "../../role/RoleSelectBox";
import HospitalSelectBox from "../../hospital/HospitalSelectBox";

// Grid ilk açılışta ve "Sıfırla"da bu süzgeçle çalışır. Formun başlangıç değerleriyle sunucuya
// gönderilen süzgeç aynı nesneden türesin diye tek yerde duruyor (eskiden Sıfırla formda "Aktif"
// gösterip listeye pasifleri de getiriyordu).
export const USER_DEFAULT_FILTER = {
    enabled: true,
    onlineMinutes: 5
};

// Çevrimiçi penceresi: kullanıcı bu süre içinde API'ye istek attıysa çevrimiçi sayılır.
// Kaynak app_logs olduğu için pencere ne kadar uzarsa "az önce açıktı" da listeye girer.
const ONLINE_WINDOW_OPTIONS = [1, 5, 15, 60];

export default function UserFilter()
{
    const {t} = useTranslation();
    const {onFilterPageSort} = useDataGrid();
    const formRef = useRef();

    const filter = (form) => {
        onFilterPageSort({
            filter: form
        })
    }

    const reset = () => {
        formRef.current.resetFields()
        onFilterPageSort({
            filter: {...USER_DEFAULT_FILTER}
        })
    }

    // Çevrimiçi süzgeci canlı bir soruya cevap verir ("şu an kim bağlı?"): seçim ayrıca "Ara"ya
    // basılmasını beklemeden uygulanır. Metin alanlarında bu istenmez (her harfte sorgu atardı),
    // o yüzden yalnızca bu iki açılır kutuda.
    const applyNow = () => formRef.current?.submit();

    return (
        <>
            <Form
                ref={formRef}
                onFinish={filter}
                layout={'vertical'}
                initialValues={USER_DEFAULT_FILTER}
            >
                <Space style={{marginBottom: 16}}>
                    <Button type={'primary'} size={'small'} htmlType="submit" >{t('Search')}</Button>
                    <Button size={'small'} onClick={reset}>{t('Reset')}</Button>
                </Space>
                <Form.Item
                    label={t('Name')}
                    name={'name'}
                >
                    <Input
                        placeholder={t('Name, Username or Email')}
                        allowClear
                    />
                </Form.Item>
                <Form.Item
                    label={t('Online')}
                    name={'online'}
                    tooltip={t('Users who sent a request to the system within the selected window')}
                >
                    <Select
                        size={'small'}
                        allowClear
                        onChange={applyNow}
                    >
                        <Select.Option value={null}>{t('All')}</Select.Option>
                        <Select.Option value={true}>{t('Online')}</Select.Option>
                        <Select.Option value={false}>{t('Offline')}</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label={t('Online Window')}
                    name={'onlineMinutes'}
                >
                    <Select
                        size={'small'}
                        onChange={applyNow}
                        options={ONLINE_WINDOW_OPTIONS.map(m => ({
                            value: m,
                            label: `${t('Last')} ${m} ${t('minutes')}`
                        }))}
                    />
                </Form.Item>
                <Form.Item
                    label={t('Role')}
                    name={'roleId'}
                >
                    <RoleSelectBox allowClear />
                </Form.Item>
                <Form.Item
                    label={t('Hospital')}
                    name={'hospitalId'}
                >
                    <HospitalSelectBox />
                </Form.Item>
                <Form.Item
                    label={t('Active/Inactive')}
                    name={'enabled'}
                >
                    <Select
                        size={'small'}
                    >
                        <Select.Option value={null}>{t('All')}</Select.Option>
                        <Select.Option value={true}>{t('Active')}</Select.Option>
                        <Select.Option value={false}>{t('Inactive')}</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </>
    )
}
